import { render, staticRenderFns } from "./HelpdeskBlockedSubjects.vue?vue&type=template&id=564e0aaa"
import script from "./HelpdeskBlockedSubjects.vue?vue&type=script&lang=js"
export * from "./HelpdeskBlockedSubjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports